import { render } from "./Deviations.vue?vue&type=template&id=4c6c558c&ts=true"
import script from "./Deviations.vue?vue&type=script&lang=ts"
export * from "./Deviations.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__